// extracted by mini-css-extract-plugin
export default {"text_area_label":"TextArea_text_area_label__wwv2B","descriptionErrorContainer":"TextArea_descriptionErrorContainer__qU79z","error":"TextArea_error__YgsD7"};